<!-- app页面——企业文档 -->
<template>
  <div class="enterpriseDocH5">
    <van-nav-bar title="企业文档" left-arrow @click-left="toBack" />
    <div class="content">
      <div v-for="(item, index) in authDocList" :key="index" class="Doc" @click="toPath(item)">
        <van-image class="Doc_logo" fit="contain" :src="getIcon(item)" />
        <span class="Doc_name">{{ item.name }}</span>
        <van-icon name="arrow" class="rightIcon" />
      </div>
      <div class="empty" v-if="!authDocList.length">暂无权限</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getMenuList } from "@/CommonDP/utils/tree";

export default {
  components: {},
  data() {
    return {
      shareInfo: require("../assets/enterpriseDocH5/shareInfo.png"), // 图标
      publicInfo: require("../assets/enterpriseDocH5/publicInfo.png"),
      recycleBin: require("../assets/personDocH5/recycleBin.png")
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes // 当前用户权限
    }),
    // 用户有权限的文档目录
    authDocList() {
      let doc = this.authRoutes.find(({ permissionKey }) => permissionKey == "doc");
      let docList = doc ? this.menuList([doc]) : []; // 知识菜单列表
      let enterprisedoc = docList.find(({ permissionKey }) => permissionKey == "enterprisedoc");
      let enterpriseList = enterprisedoc ? enterprisedoc.sub : []; // 企业文档菜单列表
      return enterpriseList;
    }
  },
  mounted() {},
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },
    // 菜单列表
    menuList(array) {
      const list = getMenuList(array) || [];
      if (list.length > 0) {
        if (list[0].sub && list[0].sub.length > 0) {
          list[0].sub = list[0].sub.filter(({ resourceType }) => resourceType == 0);
          return list[0].sub;
        }
      }
      return [];
    },

    // 模块图标
    getIcon(item) {
      let { path } = item || {};
      let icon = "";
      switch (path) {
        case "/sharinformation":
          icon = this.shareInfo;
          break;
        case "/Publicinformation":
          icon = this.publicInfo;
          break;
        case "/entprecycle":
          icon = this.recycleBin;
          break;
      }
      return icon;
    },
    // 跳转路径
    toPath(item) {
      let { path } = item || {};
      switch (path) {
        case "/sharinformation":
          this.$router.push("/enterpriseDocH5/shareInfoH5");
          break;
        case "/Publicinformation":
          this.$router.push("/enterpriseDocH5/publicInfoH5");
          break;
        case "/entprecycle":
          this.$router.push("/enterpriseDocH5/epRecycleH5");
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.enterpriseDocH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
    .empty {
      width: 100%;
      height: calc(100% - 66px);
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--info-color)9;
      font-size: 16px;
    }
  }
}

.Doc {
  width: 100vw;
  height: 70px;
  padding: 0 3vw;
  background-color: #ffffff;
  border-bottom: 1px solid #e5e8f1;
  display: flex;
  align-items: center;

  .Doc_logo {
    width: 42px;
    height: 42px;
    padding: 5px;
    margin-bottom: 2px;
  }

  .Doc_name {
    width: calc(100% - 65px);
    padding-left: 5px;
    line-height: 40px;
    font-size: 16px;
  }

  .rightIcon {
    font-size: 14px;
    color: #6f6f6f;
  }
}
</style>
